module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetLow@2x.2813469.jpg";